<template>
  <el-dialog title="备注" :visible.sync="visible" width="552px" :append-to-body="true" center class="pop-apply">
    <div class="apply-title">请确认审批结果</div>
    <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="审批结果" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio label="pass">通过</el-radio>
            <el-radio label="reject">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="comment">
          <el-input type="textarea" v-model="form.comment" :rows='4' maxlength="64" show-word-limit></el-input>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="ok">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "popApprove",
  data() {
    return {
      visible: false,
      form:{
        type:'pass',
        comment:''
      },
      rules: {
        type: [
            { required: true, message: '请选择审批结果', trigger: 'blur' },
          ]
        }

    }
  },
  created() {


  },
  methods: {
    show(value) {
      this.visible = true
      this.form.comment = value || ''
    },
    ok() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('setApprove', this.form)
          this.visible = false
        }
      })

    }
  }
}
</script>

<style lang="scss" scoped>
.pop-apply {
  .apply-title{
    font-size: 12px;
    color: #939696;
    text-align: center;
    margin-bottom: 12px;
  }
}
.pop-apply /deep/{
  .el-dialog__header{
    padding: 16px 0 0;
    height: 54px;
    box-sizing: border-box;
  }
  .el-dialog__body{
    padding: 16px 36px 0 32px;
  }
  .el-form-item{
    margin-bottom: 26px;
  }
  .el-textarea__inner {
        padding-left: 8px;
    }
  .el-dialog__footer{
    padding: 6px 0 16px;
  }
}
</style>
